import React from 'react';
import { reportSlardar } from '@oec-seller/sdk/utils/util';

const BLANK_SCREEN_EVENT = 'ticket_email_blank_screen_error_boundary';

type ErrorBoundaryProps = {
  children: JSX.Element;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

const getRootStatus = (): Record<string, string | number | boolean> => {
  const root = document.getElementById('root');

  return {
    hasRoot: Boolean(root),
    rootChildCount: root?.children?.length ?? 0,
    rootTextLength: root?.textContent?.length ?? 0
  };
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = {
    hasError: false
  };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return {
      hasError: true
    };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    reportSlardar(BLANK_SCREEN_EVENT, {
      errorName: error.name,
      errorMessage: error.message,
      errorStack: error.stack || '',
      componentStack: errorInfo.componentStack || '',
      path: window.location.pathname,
      search: window.location.search,
      href: window.location.href,
      ...getRootStatus()
    });
  }

  public render(): JSX.Element | null {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
